import { render } from "./CaseUpdateCustomer.vue?vue&type=template&id=63f063e0&scoped=true"
import script from "./CaseUpdateCustomer.vue?vue&type=script&lang=js"
export * from "./CaseUpdateCustomer.vue?vue&type=script&lang=js"

import "./CaseUpdateCustomer.vue?vue&type=style&index=0&id=63f063e0&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f063e0"]])

export default __exports__